module.exports = __webpack_public_path__ + "img/playstore.587e4d1f.svg";